import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ChallengePreview = ({ formData }) => {
  const getGoalTypeDisplay = () => {
    switch (formData?.goalType) {
      case 'fixed':
        return {
          icon: 'Target',
          label: '고정 횟수',
          detail: `${formData?.parameters?.targetCount || 0}회 목표`,
        };
      case 'split':
        return {
          icon: 'Grid3x3',
          label: '분할 목표',
          detail: `${formData?.parameters?.totalGoal || 0} → ${formData?.parameters?.splitCount || 0}단계`,
        };
      case 'thirty-day':
        return {
          icon: 'Calendar',
          label: '30일 챌린지',
          detail: formData?.parameters?.startDate || '날짜 미설정',
        };
      default:
        return { icon: 'HelpCircle', label: '유형 미선택', detail: '' };
    }
  };

  const goalDisplay = getGoalTypeDisplay();

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-2">
          미리보기
        </h3>
        <p className="text-sm text-muted-foreground caption">
          챌린지가 어떻게 표시될지 확인하세요
        </p>
      </div>
      <div className="bg-card rounded-lg border border-border overflow-hidden shadow-gaming-md">
        {formData?.coverImage ? (
          <div className="relative w-full aspect-video">
            <Image
              src={formData?.coverImage}
              alt="Challenge preview cover showing uploaded visual representation"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-background/20" />
            <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
              <h4 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-2 line-clamp-2">
                {formData?.title || '챌린지 제목'}
              </h4>
              <div className="flex items-center space-x-2">
                <div className="flex items-center space-x-1 px-2 py-1 bg-primary/20 rounded-md">
                  <Icon name={goalDisplay?.icon} size={14} color="var(--color-primary)" />
                  <span className="text-xs font-medium text-primary caption">
                    {goalDisplay?.label}
                  </span>
                </div>
                <span className="text-xs text-muted-foreground caption">
                  {goalDisplay?.detail}
                </span>
              </div>
            </div>
          </div>
        ) : (
          <div className="w-full aspect-video bg-muted flex items-center justify-center">
            <div className="text-center p-4">
              <Icon name="Image" size={48} className="text-muted-foreground mx-auto mb-2" />
              <p className="text-sm text-muted-foreground caption">
                커버 이미지 미리보기
              </p>
            </div>
          </div>
        )}

        <div className="p-4 md:p-6 space-y-4">
          <div>
            <h4 className="text-base md:text-lg font-heading font-semibold text-foreground mb-2">
              {formData?.title || '챌린지 제목을 입력하세요'}
            </h4>
            <p className="text-sm text-muted-foreground line-clamp-3">
              {formData?.description || '챌린지 설명을 입력하세요'}
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-3">
            <div className="flex items-center space-x-2 px-3 py-2 bg-muted/50 rounded-md">
              <Icon name={goalDisplay?.icon} size={16} color="var(--color-primary)" />
              <span className="text-sm font-medium text-foreground">
                {goalDisplay?.label}
              </span>
            </div>

            {formData?.settings?.defaultPublic && (
              <div className="flex items-center space-x-2 px-3 py-2 bg-success/10 rounded-md">
                <Icon name="Eye" size={16} color="var(--color-success)" />
                <span className="text-sm font-medium text-success">공개</span>
              </div>
            )}

            {formData?.settings?.sequentialUnlock !== false && (
              <div className="flex items-center space-x-2 px-3 py-2 bg-accent/10 rounded-md">
                <Icon name="Lock" size={16} color="var(--color-accent)" />
                <span className="text-sm font-medium text-accent">순차 잠금</span>
              </div>
            )}
          </div>

          <div className="pt-4 border-t border-border">
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground caption">진행률</span>
              <span className="font-medium text-foreground data-text">0%</span>
            </div>
            <div className="w-full h-2 bg-muted rounded-full mt-2">
              <div className="w-0 h-full bg-primary rounded-full transition-gaming" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengePreview;